import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, Tooltip, Typography } from '@material-ui/core';
import { AppColors } from '@lib/common';

interface Options {
  message?: string;
  stringLength?: number;
  tooltip?: string;
  error?: boolean;
}

export function renderInvoiceNumberCell(
  invoiceNumber?: string | null,
  { message = '', stringLength = 28, tooltip = '', error }: Options = {}
) {
  const formattedInvoiceNumber =
    invoiceNumber && invoiceNumber.length > stringLength
      ? invoiceNumber.match(new RegExp(`.{1,${stringLength}}`, 'g'))?.join(' ')
      : invoiceNumber;

  return (
    <Tooltip title={tooltip} placement="bottom-start">
      <Grid container spacing={1}>
        <Grid item>{error && <FontAwesomeIcon icon="info-circle" color={AppColors.Red} />}</Grid>
        <Grid item>
          <Typography color="inherit">
            {formattedInvoiceNumber ?? '--'}
            {message}
          </Typography>
        </Grid>
      </Grid>
    </Tooltip>
  );
}
